import moment from "moment";
import { dateFormat } from "us.collection.admin/constants/NonProductionDays";
import { INonProductionDay } from "us.collection.admin/interfaces";

export function AddOrUpdateNonExecutionDay(this: INonProductionDay) {
  const { id, key, dateRange, reason, criteria } = this;
  return {
    id,
    key,
    dateRange: [
      moment(dateRange[0]).startOf("day").format(dateFormat),
      moment(dateRange[1]).startOf("day").format(dateFormat),
    ],
    reason,
    criteria,
  };
}
